import { Action } from '@ngrx/store'
import { SharingGroup } from '../models'

export const SET_VIDEO_GROUPS = '[Sharing Group] Set Video Groups'
export const ADD_VIDEO_GROUP = '[Sharing Group] Add Video Group'
export const UPDATE_VIDEO_GROUP = '[Sharing Group] Update Video Group'
export const DESTROY_VIDEO_GROUP = '[Sharing Group] Destroy Video Group'
export const SET_VIDEO_MY_GROUP = '[Sharing Group] Set Video My Group'
export const SET_GROUP_FILTER_STATUS = '[Sharing Group] Set Group Filter Status'

export class SetVideoGroups implements Action {
  readonly type = SET_VIDEO_GROUPS

  constructor(public videoId: number, public groups: SharingGroup[]) { }
}

export class AddVideoGroup implements Action {
  readonly type = ADD_VIDEO_GROUP

  constructor(public videoId: number, public group: SharingGroup) { }
}

export class UpdateVideoGroup implements Action {
  readonly type = UPDATE_VIDEO_GROUP

  constructor(public videoId: number, public group: SharingGroup) { }
}

export class DestroyVideoGroup implements Action {
  readonly type = DESTROY_VIDEO_GROUP

  constructor(public videoId: number, public groupId: number) { }
}

export class SetVideoMyGroup implements Action {
  readonly type = SET_VIDEO_MY_GROUP

  constructor(public videoId: number, public group: SharingGroup) { }
}

export class SetGroupFilterStatus implements Action {
  readonly type = SET_GROUP_FILTER_STATUS

  constructor(public videoId, public filterGroupIds: number[]) {}
}

export type All = SetVideoGroups
  | AddVideoGroup
  | UpdateVideoGroup
  | DestroyVideoGroup
  | SetVideoMyGroup
  | SetGroupFilterStatus



// WEBPACK FOOTER //
// ./src/actions/sharing-group.ts